import { Component, ViewChild } from '@angular/core';
import { MenuItem, Message } from 'primeng/api';
import {
  breadcrumb,
  link,
  stat,
} from 'src/app/admin/layout/header/header.component';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { cloneDeep } from 'lodash';
import { GlobalConstants } from 'src/app/services/global-constants';
import { DataService } from 'src/app/services/data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-manager-impact-task',
  templateUrl: './manager-impact-task.component.html',
  styleUrl: './manager-impact-task.component.scss',
})
export class ManagerImpactTaskComponent {
  constructor(
    private dataService: DataService,
    public permissionService: PermissionHandlerService,
    private router: Router
  ) {}

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  header = this.translate('Impact Magerment Task');
  links: link[] = [];
  breadcrumbs: breadcrumb[] = [
    {
      name: this.translate('Impact Magerment Task'),
      link: '/training/impact-magerment-task',
    },
  ];
  stats: stat[] = [];

  translator: TranslatorPipe = new TranslatorPipe();
  messages: Message[] = [];
  skelition: boolean = true;
  currentRoute: any;
  showFilters: boolean = true;
  @ViewChild('dv')
  dataView!: DataView;
  staticURL = GlobalConstants.staticFilesURL;

  //filter Variables
  LogsToshow: any;
  statusOptions: any = [
    { name: 'PENDING', value: 1, arabic: this.translate('PENDING') },
    // { name: 'PUBLISHED', value: 2, arabic: this.translate('PUBLISHED') },
    { name: 'COMPLETED', value: 3, arabic: this.translate('COMPLETED') },
    // { name: 'REJECTED',value: 3, arabic: this.translate('REJECTED'), }
  ];

  oufilter: any = undefined;
  logType: any = undefined;
  logStatus: any = 'PENDING';

  selectedViewId = undefined;

  //filter options
  ouTypes: any;

  selectedTreeData: any = [];
  selectedTreeTags_current: any;
  selectedTreeData_orginal: any;
  types: any[] = [];
  selectedTreeTags: MenuItem[] = [];

  ngOnInit() {
    this.getTreeData();
    this.getImpactTasksData();
  }

  readonly APIURL = '/';
  impactTasks: any = [];

  async getImpactTasksData(): Promise<void> {
    try {
      this.skelition = true;

      let uid = localStorage.getItem('uid');
      if (!!!uid) return;

      let res = await this.dataService.postData(
        'training-req/get-manager-impact-task/' + uid ,{ status :  this.logStatus , ou : this.oufilter ? this.oufilter._id : undefined}
      );
      this.impactTasks = res.data;
    } catch (error) {
      console.log('Error fetching impact tasks: ', error);
    } finally {
      this.skelition = false;
    }
  }

  showUsers: boolean[] = []; // Array to store visibility state of users for each task

  // Function to toggle users visibility for the clicked task
  toggleUsers(index: number): void {
    // Toggle the value at the given index or initialize it
    this.showUsers[index] = !this.showUsers[index];
  }

  getNamesString(data: any): string {
    return data ? data.map((item: any) => item.label).join(', ') : '-';
  }

  //Get tree data and as per the  permission
  async getTreeData() {
    this.selectedTreeData_orginal =
      await this.permissionService.extractOUChildren('TRAINING_PROGRAM', 'r');
    this.filterTreeByTag([
      'Ministries/Entities',
      'Organisational Units',
      'Branches',
      'Organisational Structure',
    ]);
  }

  filterTreeByTag(tag: string[]) {
    // Create a deep copy of the selected data using lodash.clonedeep
    this.selectedTreeData = cloneDeep(this.selectedTreeData_orginal);
    this.selectedTreeData = this.selectedTreeData
      .map((node: any) => this.filterNodes(node, tag))
      .filter((filteredNode: any) => filteredNode !== null);
    console.log(this.selectedTreeData);

    if (this.selectedTreeData.length == 0) {
      let cloneitems: any = [];
      this.selectedTreeData_orginal.forEach((item: any) => {
        cloneitems.push({
          data: item.data,
          id: item.id,
          label: item.label,
          parent: item.parent,
          tag: item.tag,
          _id: item._id,
          children: [],
        });
      });
      this.selectedTreeData = cloneDeep(cloneitems);
    }
  }

  filterNodes(node: any, tag: string[]): any | null {
    // Recursively filter children nodes

    if (node.children && node.children.length > 0) {
      node.children = node.children
        .map((childNode: any) => this.filterNodes(childNode, tag))
        .filter((filteredChild: any) => filteredChild !== null);
    }

    // Include the current node if it matches the tag or any of its children do
    if (tag.includes(node.tag) || (node.children && node.children.length > 0)) {
      return node;
    }

    return null; // Exclude this node from the result
  }

  navigateToUrl(params: any) {
    let surveyId = params.surveyID;
    params.formManager = true;
    delete params.surveyID;
    const queryString = new URLSearchParams(params).toString();
    const url = `/sa/survey/attempt/${surveyId}?${queryString}`;
    window.open(url, '_blank');
}

  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }

  refresh() {
    this.oufilter = undefined;
    this.getImpactTasksData()
  }
}